let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j5BI7")).then(() => parcelRequire('94MwS'));